import { render } from "./home.vue?vue&type=template&id=637afe84&scoped=true"
const script = {}

import "./home.vue?vue&type=style&index=0&id=637afe84&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-637afe84"]])

export default __exports__